$.fn.CarouselArrows = function() {
  let self = this
  self.arrow_next = self.find('.swiper-button-next')
  self.arrow_prev = self.find('.swiper-button-prev')
  self.carousel_container = self.closest('.carousel__container')

  self.init = function() {
    self.carousel_container.addClass('--side-arrows')
    self.arrow_next.appendTo(self.carousel_container)
    self.arrow_prev.appendTo(self.carousel_container)
  }

  self.sizer = function() {
    if (self.carousel_container.hasClass('carousel--postitem__designer') ||
        self.carousel_container.hasClass('carousel--custom')) {
      self.carousel_container.css('--arrow-height', self.find('.grid__item').first().find('picture').outerHeight() / 2 + 'px');
    } else {
      self.carousel_container.css('--arrow-height', self.find('.grid__item').outerHeight() / 2 + 'px');
    }
  }

  return function() {
    self.init()

    $(window).on('resize load orientationchange', self.sizer)
    return self
  }()
}
